import { render, staticRenderFns } from "./NewsListMore.vue?vue&type=template&id=a3e151d2&comments=true"
import script from "./NewsListMore.vue?vue&type=script&lang=ts"
export * from "./NewsListMore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports